import React, { Component } from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import _ from "lodash";
import { INPUT_FIELDS } from "forms/fields/useful_link";
import Buttons from "components/elements/Buttons";
import Button from "components/elements/Button";
import { FormTitle } from "components/form";

class UsefulLinkForm extends Component {
  renderFields() {
    return INPUT_FIELDS.map((field, i) => {
      return (
        <Field
          key={i}
          viewMode={this.props.viewMode}
          editMode={this.props.editMode}
          values={this.props.values}
          {...field}
        />
      );
    });
  }

  render() {
    const { errors, dirty, isSubmitting, editMode } = this.props;
    return (
      <Form>
        <FormTitle group={"usefulLinks"} />
        {this.renderFields()}
        <div style={{ padding: 0, margin: 0 }} className="level is-mobile">
          <div className="level-item">
            <Buttons className="is-centered">
              <Button
                group="common"
                name="cancel"
                onClick={this.props.cancel}
              />
              <Button
                group="common"
                name="submit"
                className={`${
                  !_.isEmpty(errors)
                    ? "is-danger"
                    : _.isEmpty(errors) && dirty
                    ? "is-success"
                    : "is-info"
                } ${isSubmitting && "is-loading"}`}
                onClick={this.props.handleSubmit}
              />
            </Buttons>
          </div>
          {editMode && (
            <div className="level-right">
              <div className="level-item">
                <Button
                  group="common"
                  name="delete"
                  onClick={() => this.props.deleteLink(this.props.values._id)}
                />
              </div>
            </div>
          )}
        </div>
      </Form>
    );
  }
}

UsefulLinkForm = withFormik({
  mapPropsToValues({ valuesToEdit, pet }) {
    return {
      displayName: valuesToEdit.displayName || "",
      desc: valuesToEdit.desc || "",
      url: valuesToEdit.url || "",
      displayForAll: valuesToEdit.displayForAll || false,
      _id: valuesToEdit._id || "",
      _pet: valuesToEdit._pet || pet._id,
    };
  },
  validationSchema: Yup.object().shape({
    displayName: Yup.string().required("required").max(40, "max-40"),
    desc: Yup.string().max(120, "max-120"),
    url: Yup.string().url("url").required("required").max(120, "max-120"),
    displayForAll: Yup.boolean(),
  }),
  handleSubmit(values, { props, setSubmitting }) {
    if (props.editMode) {
      return props.updateLink(values, setSubmitting);
    }
    props.addToLinks(values, setSubmitting);
  },
})(UsefulLinkForm);

export default UsefulLinkForm;
